export default __webpack_public_path__ + "static/media/b6.c2271200.svg";